import { Link, useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { publicRecruitmentApi } from '../../api/publicRecruitment';
import { CareersNav } from './CareersNav';
import { useCandidateAuth } from './CandidateAuthContext';

/** Real job details only - the actual application form lives one click further, at /careers/vacancies/:id/apply. */
export function VacancyInfoPage() {
  const { id } = useParams<{ id: string }>();
  const vacancyId = Number(id);
  const vacancyQuery = useQuery({ queryKey: ['public-vacancy', vacancyId], queryFn: () => publicRecruitmentApi.getVacancy(vacancyId) });
  const { account } = useCandidateAuth();
  const navigate = useNavigate();

  const vacancy = vacancyQuery.data?.data;

  const handleApply = () => {
    if (account) navigate(`/careers/vacancies/${vacancyId}/apply`);
    else navigate(`/careers/login?next=/careers/vacancies/${vacancyId}/apply`);
  };

  return (
    <div className="careers-page">
      <CareersNav />
      <Link to="/careers">&larr; Back to Open Positions</Link>

      {vacancyQuery.isLoading && <p className="muted">Loading…</p>}
      {!vacancyQuery.isLoading && !vacancy && <div className="card"><p className="muted">This vacancy is not currently open for applications.</p></div>}

      {vacancy && (
        <>
          <header className="careers-header">
            <h1>{vacancy.position_title}</h1>
            <p className="muted">{vacancy.department_name} · {vacancy.duty_station_name}</p>
            {vacancy.closing_date && <p className="careers-deadline-notice">&#9203; Applications close {new Date(vacancy.closing_date).toLocaleDateString()}</p>}
          </header>

          <section className="card">
            <h2>Job Description</h2>
            <p>{vacancy.job_description ?? 'No description provided.'}</p>
            {vacancy.requirements && (
              <>
                <h2>Requirements</h2>
                <p className="muted">{vacancy.requirements}</p>
              </>
            )}
            <div className="form-actions">
              <button onClick={handleApply}>Apply Now</button>
            </div>
            {!account && <p className="muted">You'll need to sign in or create a candidate account to apply - your saved profile makes applying to future positions faster too.</p>}
          </section>
        </>
      )}
    </div>
  );
}
